import styled, { css } from 'styled-components/macro';
import { Box } from '@podiumhq/design-system';

export const MEDIA_QUERY_WIDTH = 650;
export const MEDIUM_MEDIA_QUERY_WIDTH = 850;

export const ButtonNoHoverStyles = css`
  &:not([disabled]):active,
  &:not([disabled]):focus,
  &:not([disabled]):hover {
    background-color: transparent;
  }
`;

export const StyledWrapper = styled(Box)`
  ${({ styles }) => ({ ...styles })};
`;

const FadeInStyles = css`
  opacity: 0;
  transition-timing-function: ease-in;

  ${({ startTransition }) =>
    startTransition &&
    css`
      opacity: 1;
    `};
`;

const FadeOutStyles = css`
  opacity: 1;
  transition-timing-function: ease-out;

  ${({ startTransition }) =>
    startTransition &&
    css`
      opacity: 0;
    `};
`;

export const FadeAnimationWrapper = styled(Box)`
  transition-duration: 200ms;

  ${({ fadeStyles }) => ({ ...fadeStyles })};

  ${({ fadeIn }) => fadeIn && FadeInStyles};
  ${({ fadeOut }) => fadeOut && FadeOutStyles};
`;

export const InputErrorMessage = styled(Box)`
  color: #c73841;
  font-size: 14px;
  line-height: 150%;
`;

export const WiggleAnimation = styled(Box)`
  animation: wiggleWiggle 0.25s ease-in-out;

  @keyframes wiggleWiggle {
    0% {
      transform: translateX(24px);
      opacity: 0;
    }
    50% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const border = 'none';
export const buttonGhostLinkStyles = {
  bg: 'transparent',
  border,
  variant: 'ghost',
  _active: { border },
  _focus: { border },
  _hover: { background: 'none' },
};

export const inputErrorMessageStyles = {
  color: 'red.dark',
  fontSize: 'md',
  fontWeight: 'normal',
};

export const fullPageCenterContentWrapperStyles = {
  alignItems: 'center',
  bottom: '0',
  left: '0',
  height: '100%',
  justifyContent: 'center',
  position: 'absolute',
  right: '0',
  top: '0',
  width: '100%',
};
